import DeployingFromGitHub from "../../../../src/courses/partials/responsible-development/deploying-from-version-control/github.mdx";
import * as React from 'react';
export default {
  DeployingFromGitHub,
  React
};